<template>
  <div class="w-full">
    <SuccessButton
      class="mr-6"
      :disabled="!$atividades.permissoes.includes(14)"
      @func="modalCadastroMetodologia = true"
    ></SuccessButton>
    <SideBar
      title="Cadastrar metodologia"
      @hide="modalCadastroMetodologia = false"
      :active="modalCadastroMetodologia"
      @success="submitForm()"
      size="small"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              name="nome"
              v-validate="'required'"
              label="Nome"
              v-model="metodologia.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "ModalCadastroMetodologia",
  data() {
    return {
      metodologia: {},
      modalCadastroMetodologia: false,
      error: false
    };
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.cadastrarMetodologia();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async cadastrarMetodologia() {
      this.$vs.loading();
      try {
        const res = await this.$http.post("metodologia", this.metodologia);
        this.metodologia = {};
        this.$vs.notify(this.$notify.Success);
        this.modalCadastroMetodologia = false;
        // let logData = {
        //     id_colaborador: localStorage.getItem("id"),
        //     funcao: 'cadastrar',
        //     setor: 'comercial',
        //     ip: window.localStorage.getItem("ip"),
        //     texto: 'Cadastro da metodologia N°' + res.id}
        //   await this.$logger(logData)
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        await this.$emit("update");
      }
    }
  },
  components: components
};
</script>

<style></style>
